import { Box } from "@mui/material";
import React from "react";
import MiniDrawer from "./Sidebar";
import { Outlet } from "react-router-dom"; // This is where nested components (like Services or Analytics) will render

const Home = () => {
  return (
    <Box sx={{ display: "flex", pt: { lg: "10px", xl: "20px" } }}>
      <Box>
        <MiniDrawer />
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          // ml: "60px",
          overflow: "hidden",
          mt:  5.5
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default Home;
